import { I18nPluralPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconTypes } from '@shared/v2';
import { SdvorIconComponent } from '../icon/icon.component';

@Component({
  selector: 'sd-bonus-widget',
  imports: [SdvorIconComponent, I18nPluralPipe],
  templateUrl: './bonus-widget.component.html',
  styleUrls: ['./bonus-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BonusWidgetComponent {
  @Input() amount?: number | string;
  @Input() isPromo?: boolean;
  @Input() withWord?: boolean;

  protected readonly iconTypes = IconTypes;

  protected readonly bonusWordMap: { [key: string]: string } = {
    one: 'балл',
    few: 'балла',
    many: 'баллов',
    other: 'баллов',
  };
}
